<template>
<!-- 登岛活动页面 -->
  <div class="introduction-main">
    <!-- 说明 -->
    <div v-if="pageNum==1" class="des">
        <div @click="$router.push('/ceping80_activity_rules?pageNum=1')" class="left-text"></div>
        <div class="userinfo">
            <div class="money">
                <img  src="@a/ceping80/money-mini.png" alt="">{{moneyShow?0:userInfo.score}}
            </div>
            <img :src="userInfo.headimgurl" class="user-img-link" alt="">
        </div>
        <!--  -->
        <h3>【序：幸福勋章】</h3>
        <h4>在遥远的霍氏海域，<br/>有6个各具风情的神秘岛，<br/>岛上还有神秘“宝箱”，<br/>让我们一起踏上探索之旅吧~</h4>
        <img class="btn animated pulse infinite" @click="desHandle(true)" src="@a/ceping80/des-btn.png" alt="">
        <p>更多章节，敬请期待…</p>
    </div>
    <!-- 岛屿选择 -->
    <div  v-if="pageNum==2" class="island animated fadeInLeft">
        <!-- 活动规则和金币 -->
        <div  @click="$router.push('/ceping80_activity_rules?pageNum=2')" class="left-text"></div>
        <div class="userinfo">
            <div class="money">
                <img  src="@a/ceping80/money-mini.png" alt="">{{userInfo.score}}
            </div>
            <img :src="userInfo.headimgurl" class="user-img-link" alt="">
        </div>
        <!--  -->
        <van-swipe ref="swiper" class="my-swipe" :show-indicators="false" @change="swiperHandle">
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/e-max.png" alt="">
            </van-swipe-item>
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/i-max.png" alt="">
            </van-swipe-item>
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/s-max.png" alt="">
            </van-swipe-item>
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/a-max.png" alt="">
            </van-swipe-item>
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/c-max.png" alt="">
            </van-swipe-item>
            <van-swipe-item class="swipe-item">
                <img class="dengdao animated shake infinite" src="@a/ceping80/r-max.png" alt="">
            </van-swipe-item>
        </van-swipe>
        <img @click="changeSwipe('up')" class="hd-left" src="@a/ceping80/hd-left.png" alt="">
        <img @click="changeSwipe('down')" class="hd-right" src="@a/ceping80/hd-right.png" alt="">
        <!-- 标题 -->
        <div class="island-title">
            <h3>{{islandArr[swiperIdx].title}}</h3>
            <h4>{{islandArr[swiperIdx].des}}</h4>
            <div @click="jianjieShow=true" class="jianjie">查看全部简介</div>
        </div>
        <!-- 小岛屿 -->
        <div class="mini-island">
            <div class="mini-island-img">
                <img @click="changeSwipe('up')" src="@a/ceping80/an-left.png" alt="">

                <img  @click="changeSwipe('to',0)" v-if="swiperIdx==0" src="@a/ceping80/e-mini-on.png" alt="">
                <img  @click="changeSwipe('to',0)" v-else src="@a/ceping80/e-mini.png" alt="">

                <img  @click="changeSwipe('to',1)" v-if="swiperIdx==1" src="@a/ceping80/i-mini-on.png" alt="">
                <img  @click="changeSwipe('to',1)" v-else src="@a/ceping80/i-mini.png" alt="">

                <img  @click="changeSwipe('to',2)" v-if="swiperIdx==2" src="@a/ceping80/s-mini-on.png" alt="">
                <img  @click="changeSwipe('to',2)" v-else src="@a/ceping80/s-mini.png" alt="">

                <img  @click="changeSwipe('to',3)" v-if="swiperIdx==3" src="@a/ceping80/a-mini-on.png" alt="">
                <img  @click="changeSwipe('to',3)" v-else src="@a/ceping80/a-mini.png" alt="">

                <img  @click="changeSwipe('to',4)" v-if="swiperIdx==4" src="@a/ceping80/c-mini-on.png" alt="">
                <img  @click="changeSwipe('to',4)" v-else src="@a/ceping80/c-mini.png" alt="">

                <img  @click="changeSwipe('to',5)" v-if="swiperIdx==5" src="@a/ceping80/r-mini-on.png" alt="">
                <img  @click="changeSwipe('to',5)" v-else src="@a/ceping80/r-mini.png" alt="">

                <img @click="changeSwipe('down')" src="@a/ceping80/an-right.png" alt="">
            </div>
            <!--  -->
            <a class="dengdao-btn">
                <img class="animated pulse infinite" @click="cfmLanding=true" src="@a/ceping80/ascend-island.png" alt="">
            </a>
        </div>
    </div>
    <!-- 金币效果 -->
    <div class="money-an" v-if="moneyShow">
        <p class="text">+300</p>
        <img src="@a/ceping80/money.png" alt="">
        <div class="small">恭喜你收到新精英赠送的300探索币！</div>
        <a class="btn" @click="desHandle(false)">开心收下</a>
    </div>
    <!-- 简介 -->
    <van-popup class="jienjie-pop" v-model="jianjieShow">
        <div class="jj-box">
            <h4>{{islandArr[swiperIdx].title+'简介'}}</h4>
            <p v-html="islandArr[swiperIdx].content"></p>
        </div>
    </van-popup>
    <!-- 确认登岛 -->
    <van-popup class="jienjie-pop cfm-landing" v-model="cfmLanding">
        <div class="jj-box">
            <p>确认登陆{{islandArr[swiperIdx].title}}吗？本次登岛探索消耗200探索币。</p>
            <div class="btn">
                <a class="can" @click="cfmLanding=false">取消</a>
                <a class="cfm" @click="landingHanele()">确认</a>
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
import { ceping80_info,ceping80_log_activity,ceping_event } from "@/api/measurement";
import { queryString, getStorage, setStorage, deleteStorage, deepCopy, mobileOrWin} from "@/utils/tools";
export default {
    data(){
        return{
            cid: 80,
            pageNum:1,
            swiperIdx:0,
            islandArr:[
                {
                    type:'E',
                    title:'显赫富庶岛',
                    des:'经济高度发展的贸易之岛',
                    content:'该岛经济高度发展，处处高级饭店、俱乐部、高尔夫球场。岛民性格热情豪爽，善于企业经营和贸易活动。岛上往来者多是企业家、经理人、政治家、律师等等。这些商界名流与上等阶层人士在岛上享受着高品质生活。'
                },
                {
                    type:'I',
                    title:'深思冥想岛',
                    des:'平畴绿野人少僻静的学术之岛',
                    content:'这个岛平畴绿野，人少僻静，适合夜观星象。岛上有很多天文馆、科技博物馆、科学图书馆。<br/>岛民们最喜欢猫在自己的小房子里，天天钻研学问，沉思冥想，探究真知。<br/>哲学家、科学家和心理学家们在这里约会，讨论学术，交流思想。'
                },
                {
                    type:'S',
                    title:'温暖友善岛',
                    des:'充满人文气息的温暖之岛',
                    content:'这个岛的岛民们都性情温和，乐于助人，人际关系十分友善。大家互助合作，重视教育后代。每个社区都能自成一个密切互动的服务网络，处处充满着人文关怀气息'
                },
                {
                    type:'A',
                    title:'美丽浪漫岛',
                    des:'弥漫浓厚浪漫气息的艺术之岛',
                    content:'这个岛上到处是美术馆、音乐厅，弥漫着浓厚的艺术文化气息。岛民们保留着传统的舞蹈、音乐与绘画。许多文艺界人士都喜欢来到这里开沙龙派对寻求灵感。'
                },
                {
                    type:'C',
                    title:'现代井然岛',
                    des:'处处耸立现代建筑的都市之岛',
                    content:'处处耸立着的现代建筑，标志着这是一个进步的、都市形态的岛屿，岛上的户政管理、地政管理及金融管理都十分完善。岛民们个性冷静保守，处事有条不紊，善于组织规划。'
                },
                {
                    type:'R',
                    title:'自然原始岛',
                    des:'自然生态优良的绿色之岛',
                    content:'这是个自然生态优良的绿色之岛。岛上不仅保留有热带雨林等原始生态系统，而且建立了相当规模的植物园、动物园、水族馆。岛民以手工制造见长，他们自己种植花果，栽培蔬菜，修缮房屋，打造器物，制作工具。'
                }
            ],
            moneyShow:false,
            userInfo:{},
            jianjieShow:false,
            cfmLanding:false
        }
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 登岛
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 17:03:01
        */
        landingHanele(){
            //调用加载中
            this.$emit("loadingHandle", true, "努力登岛中...");
            ceping80_log_activity({
                type:1,
                extra:this.islandArr[this.swiperIdx].type
            }).then((data)=>{
                //关闭加载中
                this.$emit("loadingHandle", false);
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                this.$router.push({
                    path:'/ceping80_report',
                    query:{
                        extra:this.islandArr[this.swiperIdx].type
                    }
                });

            });
        },
        /*
         *@param: 
         *@return: 
         *@Description: 点击开始探索触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 17:03:01
        */
        desHandle(bool){
            // 是否是第一次进来
            if(bool){
                this.pullData();
                this.pageNum = 2;
            }else{
                // this.pullData();
                // this.pageNum = 2;
                this.moneyShow = false;
                setStorage(this.$route.path,'money',1);
            }
        },
        /*
         *@param: up:左，down:右
         *@return: 
         *@Description: 点击左右按钮实现左右切换
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 17:03:01
        */
        changeSwipe(type,idx) {
        if(type == 'up') {
            if(this.swiperIdx<=0){
                this.swiperIdx = 5;
            }else{
                this.swiperIdx -= 1;
            }
        } else if (type == 'down') {
            if(this.swiperIdx>=5){
                this.swiperIdx = 0;
            }else{
                this.swiperIdx += 1;
            }
        }else if (type == 'to') {
            this.swiperIdx = idx;
        }
        this.$refs.swiper.swipeTo(this.swiperIdx);
        },
        /*
         *@param:
         *@return: 
         *@Description: 滑动轮播触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 17:03:01
        */
        swiperHandle(index){
            if(index>5){
                this.swiperIdx = 0;
            }else{
                this.swiperIdx = index;
            }
            
        },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化获取数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-23 17:03:46
        */
        pullData(){
            if(this.$route.query.pageNum){
                this.pageNum = this.$route.query.pageNum;
            }
            //调用加载中
            this.$emit("loadingHandle", true, "拼命加载中...");
            ceping80_info().then((data)=>{
                document.title = '海岛历险';
                //关闭加载中
                this.$emit("loadingHandle", false);
                if (data.code == "10002") {
                    this.$toast(data.msg);
                    return
                }
                if(data.select_list.length>0){
                    this.$router.push({
                        path:'/ceping80_report',
                        query:{
                            extra:data.select_list[0].extra
                        }
                    });
                }
                this.userInfo = data;
                if(!getStorage(this.$route.path,'money') || getStorage(this.$route.path,'money')==0){
                    this.moneyShow = true;
                }

                ceping_event({ lead_sid: this.$route.query.lead_sid,
                  cid: this.cid,
                  event: 'ViewIndex',
                }).then(res=>{
                  // 页面访问统计
                });
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.introduction-main{
    .des{
        position: fixed;
        width: 750px;
        height: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: url(../../../assets/ceping80/des-bg.png) center no-repeat;
        background-size: 100% 100%;
        padding: 267px 50px 0px;
        text-align: center;
        overflow-y: auto;
        .userinfo{
            position:absolute;
            right: 30px;
            top: 30px;
            display: flex;
            align-items: center;
            .money{
                width: 100px;
                height: 40px;
                background: rgba($color: #ffffff, $alpha: 0.5);
                border-radius: 20px;
                font-size: 24px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                    margin-left: 5px;
                    -webkit-animation: slateY1 2s linear infinite;
                    animation:slateY1 2s linear infinite;
                }
                
                @keyframes slateY1 { 
                    from { /*动画起始状态*/
                    -webkit-transform: rotate(0deg);
                    }
                    to { /*动画结束状态*/
                    -webkit-transform: rotateY(360deg);
                    }
                }
            }
            .user-img-link{
                margin-left: 20px;
                width: 64px;
                height: 64px;
                border-radius: 50%;
                background-color: #f0f0f0;
            }
        }
        .left-text{
            position: absolute;
            top: 30px;
            left: 0;
            width: 120px;
            height: 40px;
            background: transparent;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
        }
        h3{
            color: #ffffff;
            font-size: 72px;
            line-height: 1;
            text-shadow: 0px 3px 0px #0089CF;
            margin-bottom: 85px;
            font-weight: bold;
        }
        h4{
            font-size: 36px;
            color: #0070BA;
            line-height: 72px;
            text-align: center;
            font-weight: bold;
            margin-bottom: 400px;
        }
        .btn{
            width: 375px;
            height: 107px;
            margin-bottom: 45px;
        }
        p{
            color: #FFFFFF;
            font-size: 24px;
            line-height: 1;
            margin-bottom: 45px;
        }
    }

    // 登岛
    .island{
        position: absolute;
        width: 750px;
        height: 1334px;
        background: url(../../../assets/ceping80/ascend-island-bg.png) center no-repeat;
        background-size: cover;
        padding: 236px 0px 0px;
        text-align: center;
        overflow-y: auto;
        .left-text{
            position: absolute;
            top: 30px;
            left: 0;
            width: 120px;
            height: 40px;
            background: transparent;
            border-top-right-radius: 30px;
            border-bottom-right-radius: 30px;
        }
        .userinfo{
            position:absolute;
            right: 30px;
            top: 30px;
            display: flex;
            align-items: center;
            .money{
                width: 100px;
                height: 40px;
                background: rgba($color: #ffffff, $alpha: 0.5);
                border-radius: 20px;
                font-size: 24px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 8px;
                    margin-left: 5px;
                    -webkit-animation: slateY1 2s linear infinite;
                    animation:slateY1 2s linear infinite;
                }
                
                @keyframes slateY1 { 
                    from { /*动画起始状态*/
                    -webkit-transform: rotate(0deg);
                    }
                    to { /*动画结束状态*/
                    -webkit-transform: rotateY(360deg);
                    }
                }
            }
            .user-img-link{
                margin-left: 20px;
                width: 64px;
                height: 64px;
                border-radius: 50%;
                background-color: #f0f0f0;
            }
        }
        .my-swipe{
            text-align: center;
            touch-action: none;
            .swipe-item{
                touch-action: none;
                width: 750px !important;
                .dengdao{
                    width: 662px;
                    position: relative;
                    z-index: 3;
                    animation-duration: 30s;
                }
            }
            
        }
        .island-title{
            position: absolute;
            top: 202px;
            left: 0;
            width: 100%;
            text-align: center;
            z-index: 1;
            h3{
                font-size: 90px;
                font-weight: bold;
                color: #ffffff;
                text-shadow: 0px 3px 0px #0089CF;
                margin-bottom: 30px;
                line-height: 1;
            }
            h4{
                color: #ffffff;
                font-size: 36px;
                line-height: 1;
                margin-bottom: 20px;

            }
            .jianjie{
                position: relative;
                z-index: 10;
                background-color: #06B8FF;
                color: #ffffff;
                width: 180px;
                line-height: 44px;
                border-radius: 22px;
                font-size: 24px;
                margin: 0 auto;
            }
        }
        .mini-island{
            max-width: 750px;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 527px;
            position: absolute;
            background: url(../../../assets/ceping80/water.png) center no-repeat;
            background-size: cover;
            .mini-island-img{
                display: flex;
                align-items: flex-end;
                justify-content: center;
                margin-top: 229px;
                height: 80px;
                img{
                    margin-left: 15px;
                    width: 57px;
                    &:last-of-type{
                        margin-left: 26px;
                        width: 55px;
                        height: 55px;
                    }
                    &:nth-of-type(1){
                        width: 55px;
                        height: 55px;
                    }
                    &:nth-of-type(2){
                        margin-left: 26px;
                    }
                }
            }
            .dengdao-btn{
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 50px;
                img{
                    width: 375px;
                    height: 107px;
                }
            }
        }
    }
    .hd-left{
        width: 72px;
        height: 68px;
        position: fixed;
        top: 553px;
        left:10px ;
    }
    .hd-right{
        width: 72px;
        height: 68px;
        position: fixed;
        top: 553px;
        right:10px;
    }
    .money-an{
        position: fixed;
        width: 100%;
        max-width: 750px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.6);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .text{
            // position: absolute;
            // top: 30%;
            // left: 50%;
            // transform: translateX(-50%);
            margin-bottom: 60px;
            font-size: 48px;
            color: #FDDD43;
            // animation:text1 3s linear infinite;
        }
        @keyframes text1 { 
            from { /*动画起始状态*/
                opacity: 1;
                top: 30%;
            }
            to { /*动画结束状态*/
                opacity: 0;
                top: 20%;
            }
        }
        img{
            width: 206px;
            // animation:slateY2 1.5s linear infinite;
        }
        @keyframes slateY2 { 
            from { /*动画起始状态*/
            -webkit-transform: rotate(0deg);
            }
            to { /*动画结束状态*/
            -webkit-transform: rotateY(360deg);
            }
        }
        .small{
            margin: 35px auto 30px;
            font-size: 24px;
            color: #FFFFFF;
            text-align: center;
        }
        .btn{
            display: block;
            width: 320px;
            margin: 0 auto;
            color: #FFFFFF;
            text-shadow: 0px 2px 4px rgba(234, 138, 0, 0.53);
            font-size: 36px;
            text-align: center;
            line-height: 80px;
            background: linear-gradient(0deg, #FBE537 0%, #FFA107 100%);
            border-radius: 40px 40px 40px 40px;
        }
    }
}
</style>
<style lang="scss">
    .my-swipe{
        display: flex;
        flex-direction: column;
        .van-swipe__track{
            display: flex;
            .swipe-item{
                margin-top: auto;
            }
        }
    }
    .jienjie-pop{
        background: transparent;
        .jj-box{
            width: 590px;
            background: #FFFFFF;
            border-radius: 20px;
            padding: 80px 60px 70px;
            h4{
                font-size: 36px;
                color: #333333;
                line-height: 1;
                margin-bottom: 36px;
                font-weight: bold;
                text-align: center;
            }
            p{
                font-size: 28px;
                color: #333333;
                line-height: 40px;
            }
        }
    }
    .jienjie-pop.cfm-landing{
        padding: 70px 60px 60px;
        p{
            margin-bottom: 60px;
        }
        .btn{
            display: flex;
            justify-content: space-between;
            text-align: center;
            .can{
                background:#F7F8F9 ;
                width: 200px;
                height: 80px;
                line-height: 80px;
                border-radius: 40px;
                font-size: 36px;
                color: #2B333A;
                font-weight: bold;
            }
            .cfm{
                width: 200px;
                height: 80px;
                line-height: 80px;
                font-size: 36px;
                color: #ffffff;
                font-weight: bold;
                background: linear-gradient(0deg, #FFA208 0%, #FBE436 100%);
                border-radius: 40px;
            }
        }
    }
</style>